// extracted by mini-css-extract-plugin
export default {"container":"pca-z","list":"qca-z"};